import { Component, signal } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { isDismissed, setDismissed } from '../../core/storage/dismissed-storage';

/** Nabídka celosborových školení na webu, kam vede tlačítko i odkaz na program. */
export const TRAINING_URL = 'https://mapavyuky.cz/skoleni.html';

/** Název školení — na kartě i v objednávce z chatu. */
export const TRAINING_TITLE = 'Revize RVP v praxi školy: od nového kurikula k ŠVP a výuce';

/** Sleva na školení pro uživatele Mapy výuky, v procentech. */
export const TRAINING_DISCOUNT_PERCENT = 15;

/**
 * Skrytí platí jen do konce přihlášení: `AuthService.clearSession()` klíč maže, takže se karta po
 * každém dalším přihlášení připomene znovu.
 */
export const TRAINING_DISMISSED_KEY = 'training-card-dismissed';

/**
 * Pozvánka na celosborové školení „Revize RVP v praxi školy“. Nic se tu neobjednává — objednávka i
 * podrobný program jsou na webu, karta jen shrne, pro koho školení je, co se na něm probírá, že ho
 * lze hradit z OP JAK a že uživatelé Mapy výuky mají slevu 15 %.
 *
 * Po skrytí zůstává karta schovaná až do dalšího přihlášení.
 */
@Component({
  selector: 'app-training-card',
  imports: [MatButton, MatIconButton, MatIcon],
  host: {
    '[class.hidden]': 'hidden()',
  },
  templateUrl: './training-card.html',
})
export class TrainingCard {
  readonly trainingUrl = TRAINING_URL;
  readonly trainingTitle = TRAINING_TITLE;
  readonly discountPercent = TRAINING_DISCOUNT_PERCENT;

  readonly topicsOpen = signal(false);

  readonly hidden = signal(isDismissed(TRAINING_DISMISSED_KEY));

  readonly topics = [
    'Co revidované RVP ZV skutečně mění: očekávané výsledky učení, klíčové kompetence, základní gramotnosti a průřezová témata a jejich rozdílná váha v kurikulu',
    'Jak tvořit nový ŠVP inventurou stávající výuky, aniž by škola začínala od nuly',
    'Tematické plány jako spojovací článek mezi školním kurikulem a každodenní výukou',
    'Jak krok za krokem mapovat tematické bloky na požadavky RVP',
    'Vize a kurikulární priority školy: na čem se sbor musí dohodnout a co zůstává na učiteli',
  ];

  toggleTopics(): void {
    this.topicsOpen.update((open) => !open);
  }

  dismiss(): void {
    setDismissed(TRAINING_DISMISSED_KEY);
    this.hidden.set(true);
  }
}
